import initMinigallery from './packages/package-minigallery';
import { initAccordions, protectNextButtonByRadio } from './utils';

window.com.parkside.dielenart = {};
window.com.parkside.dielenart.init = function () {
  const inputName = 'surface_product_tree_id';
  protectNextButtonByRadio(inputName);
  initAccordions();
  initMinigallery();

  document.querySelectorAll('.radio-dotted').forEach(e => {
    e.addEventListener('click', function () {
      e.querySelector('input[type="radio"]').checked = true;
    });
  });

  jQuery('.btn-next').click(function () {
    var $input = jQuery(`input[name=${inputName}]:checked`);

    if (!$input.length) {
      alert(tp_trans.trans('no_dielenausfuehrung_selected_alert', 'Wählen Sie bitte die Dielenausführung aus.'));
    }
  });
};
